//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatTime } from './helpers.js'

export default {
  name: 'IssuedVehicleDocumentLink',
  props: {
    object: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      formatTime
    }
  },
  computed: {
    documentLink: function () {
      const object = this.object
      if (!object) {
        return null
      }
      const waybills = this.documents(object.waybill)
      const records = this.documents(object.vehiclesWithoutWaybill)
      if (this.row) {
        const waybill = waybills.find(item => item.vehicleId == this.row.id)
        if (waybill) {
          return this.waybillLink(waybill, this.row)
        }
        const record = records.find(item => item.vehicleId == this.row.id)
        return record ? this.journalLink(record, this.row) : null
      }
      if (this.item) {
        const waybill = waybills.find(item => item.driverId == this.item.id)
        if (waybill) {
          return this.waybillLink(waybill)
        }
        const record = records.find(item => item.receiverEmployeeFIO === this.item.name)
        if (record) {
          return this.journalLink(record)
        }
        if (waybills.length + records.length === 1) {
          return waybills.length ? this.waybillLink(waybills[0]) : this.journalLink(records[0])
        }
        return null
      }
      if (waybills.length) {
        return this.waybillLink(waybills[0])
      }
      return records.length ? this.journalLink(records[0]) : null
    }
  },
  methods: {
    documents: function (value) {
      const list = value == null ? [] : (Array.isArray(value) ? value : [value])
      return list.filter(item => item && item.id != null)
    },
    waybillLink: function (waybill, vehicle) {
      return {
        to: '/transport/waybill/' + waybill.id,
        color: 'primary',
        hasWaybill: true,
        number: waybill.number,
        model: (vehicle && vehicle.model) || waybill.vehicleBrand,
        driver: waybill.driverFIO,
        issuanceTime: waybill.issuanceTime,
        deliveryTime: waybill.deliveryTime
      }
    },
    journalLink: function (record, vehicle) {
      return {
        to: '/transport/vehicleIssuance/' + record.id,
        color: 'black',
        hasWaybill: false,
        model: (vehicle && vehicle.model) || record.vehicleModel,
        driver: record.receiverEmployeeFIO,
        issuanceTime: record.operationDate
      }
    }
  }
}
